<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <div class="btn-box">
          <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin: 0 5px;">考勤日期</span>
          <el-date-picker v-model="attendanceTimeValue" size="small" type="daterange" style="width: 280px;"
                          :picker-options="pickerOptions3" range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期"
                          align="right" value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
<!--        <button-add :pathName="addDataParkHonor"/>-->
        <!--<button-delete @deleteSelection="deleteSelection" />-->
      </div>
      <div class="btn-box">
        <input-select selectTitle="上班打卡结果" selectKey="checkInResult" selectWidth="165px" :selectData="checkInResultList" @search="search" style="margin-right: 10px;"/>
        <input-select selectTitle="下班打卡结果" selectKey="checkOutResult" selectWidth="165px" :selectData="checkOutResultList" @search="search" style="margin-right: 10px;"/>
      </div>
      <div style="display: flex;justify-content: space-between;">
        <input-search placeholder="员工姓名/班组名称" @search="searchKey" />
        <button-export
          style="margin-left: 5px"
          :href="exportUrl"
          download="download.xls"
          :beforeDownload="beforeDownload"
          value="导出"/>
      </div>
    </div>
    <table-main :selection="false" :hasOperation="false" :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" :deleteTipInfo="'是否确认删除该排班？'" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/AttendancePoint'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nAlert, nError, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb
    },
    name: 'attendance-record-manage',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧考勤',
          name: 'attendance-department-manage'
        }, {
          value: '考勤记录'
        }],
        exportUrl: '',
        attendanceTimeValue: [],
        pickerOptions3: {
          shortcuts: [{
            text: '近一年',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(end.getTime() - 3600 * 1000 * 24 * 365)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '近三年',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(end.getTime() - 3600 * 1000 * 24 * 365 * 3)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '近五年',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(end.getTime() - 3600 * 1000 * 24 * 365 * 5)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        operationArr: ['modify', 'delete'],

        checkInResultList: [
          {key: '', label: '全部'},
          {key: '1', label: '正常'},
          {key: '2', label: '迟到'},
          {key: '3', label: '早退'},
          {key: '4', label: '缺卡'},
          {key: '5', label: '请假'},
          {key: '6', label: '调休'},
          {key: '7', label: '旷工'},
        ],

        checkOutResultList: [
          {key: '', label: '全部'},
          {key: '1', label: '正常'},
          {key: '2', label: '迟到'},
          {key: '3', label: '早退'},
          {key: '4', label: '缺卡'},
          {key: '5', label: '请假'},
          {key: '6', label: '调休'},
          {key: '7', label: '旷工'},
        ],

        tableHead: [{
          prop: 'personName',
          label: '员工姓名'
        }, {
          prop: 'groupName',
          label: '班组名称'
        }, {
          prop: 'classesName',
          label: '班次名称'
        }, {
          prop: 'workDate',
          label: '考勤日期'
        }, {
          prop: 'checkInTime',
          label: '上班打卡时间'
        }, {
          prop: 'checkInResultText',
          label: '上班打卡结果'
        }, {
          prop: 'checkOutTime',
          label: '下班打卡时间'
        }, {
          prop: 'checkOutResultText',
          label: '下班打卡结果'
        }, {
          prop: 'workingHours',
          label: '工时(小时)'
        }],
        tableData: [],
        total: 0,
        selectionArr: [],
        requestData: {
          checkInResult: '',
          checkOutResult: '',
          searchKey: '',
          pageSize: 10,
          pageNum: 1,
          startTime: '',
          endTime: ''
        },
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    activated() {
      this.getPage()
    },
    methods: {
      beforeDownload () {
        this.exportUrl = `${api.exportAttendanceRecord}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&startTime=${this.requestData.startTime}&endTime=${this.requestData.endTime}`
      },
      getPage () {
        if (this.attendanceTimeValue) {
          this.requestData.startTime = this.attendanceTimeValue[0] || ''
          this.requestData.endTime = this.attendanceTimeValue[1] || ''
        } else {
          this.requestData.startTime = ''
          this.requestData.endTime = ''
        }
        this.$axios.post(api.getAttendanceRecordPage, this.requestData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {
                this.checkInResultList.map(checkItem => {
                  if (checkItem.key === v.checkInResult) {
                    v.checkInResultText = checkItem.label
                  }
                })
                this.checkOutResultList.map(checkItem => {
                  if (checkItem.key === v.checkOutResult) {
                    v.checkOutResultText = checkItem.label
                  }
                })
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取数据失败'))
      },
      search (v) {
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.requestData.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.requestData.pageNum = data[0]
        this.requestData.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      goToModifyPage (code) {
        this.$router.push({
          path: '/attendance_team_modify/' + code
        })
      },

      deleteLine (code) {
        this.$axios.post(api.deletePowerRoomByCodes, code)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('删除成功')
              this.selectionArr = []
              this.getPage()
            }
          })
          .catch(errorHandler('删除失败'))
      }
    },
    watch: {
      attendanceTimeValue (val) {
        this.getPage()
      }
    }
  }
</script>

<style scoped>
  .form-line {
    width: 420px;
    margin: 20px auto;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .red {
    color: red;
  }
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/view/WorkAttendance/AttendanceRecord/AttendanceRecordManage.vue